module.exports = __webpack_public_path__ + "img/MG_4695R-scaled.6f6c459f.jpg";